<template>
    <footer v-if="!hideFooter" :class="{'footer--profile-spacing': isProfileView}">
        <div class="container">
            <div class="row">
                <div class="col-12 mb-2 mb-md-3">
                    <div class="accordion accordion--footer"
                         v-if="lodash.get(regionData, 'footerLinks.popularSearches1.length', 0)">
                        <div aria-controls="footer-popular-searches1"
                             class="footer-section-heading collapsed"
                             :aria-expanded="String(accordionsOpenByDefault)"
                             data-target="#footer-popular-searches1"
                             data-toggle="collapse">{{ translate.home.popularSearches }}
                        </div>
                        <div class="accordion-content collapse"
                             :class="{show: accordionsOpenByDefault}"
                             id="footer-popular-searches1">
                            <ul class="footer-list">
                                <li v-for="link in lodash.get(regionData, 'footerLinks.popularSearches1', [])">
                                    <a class="white-badge" :href="link.path">{{ link.title }}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="col-12 mb-2 mb-md-3">
                    <div class="accordion accordion--footer"
                         v-if="lodash.get(regionData, 'footerLinks.popularSearches2.length', 0)">
                        <div aria-controls="footer-popular-searches2"
                             class="footer-section-heading collapsed"
                             :aria-expanded="String(accordionsOpenByDefault)"
                             data-target="#footer-popular-searches2"
                             data-toggle="collapse">{{ translate.home.morePopularSearches }}
                        </div>
                        <div class="accordion-content collapse"
                             :class="{show: accordionsOpenByDefault}"
                             id="footer-popular-searches2">
                            <ul class="footer-list">
                                <li v-for="link in lodash.get(regionData, 'footerLinks.popularSearches2', [])">
                                    <a class="white-badge" :href="link.path">{{ link.title }}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="col-12">
                    <div class="accordion accordion--footer">
                        <div aria-controls="footer-legals"
                             class="footer-section-heading collapsed"
                             data-target="#footer-legals"
                             data-toggle="collapse">{{ translate.home.legals }}
                        </div>
                        <div class="accordion-content collapse"
                             id="footer-legals">
                            <ul class="footer-list links">
                                <li>
                                    <a :href="ourMissionUrl">
                                        {{ translate.home.ourMission }}
                                    </a>
                                </li>
                                <li>
                                    <a :href="termsUrl">
                                        {{ translate.home.termsAndConditions }}
                                    </a>
                                </li>
                                <li>
                                    <a :href="privacyPolicyUrl">
                                        {{ translate.home.privacyPolicy }}
                                    </a>
                                </li>
                                <li>
                                    <a :href="cookiePolicyUrl">
                                        {{ translate.home.cookiePolicy }}
                                    </a>
                                </li>
                                <li>
                                    <a :href="imprintUrl">
                                        {{ translate.home.imprint }}
                                    </a>
                                </li>
                                <li v-if="isFostaSestaActive">
                                    <a href="/fosta-sesta/">
                                        FOSTA-SESTA
                                    </a>
                                </li>
                                <li v-if="isUkRegion">
                                    <a href="/prostitution-laws-worldwide/">
                                        {{ translate.home.sexWorkLawsWorldwide }}
                                    </a>
                                </li>
                            </ul>

                            <div class="footer-images">
                                <div class="d-flex align-items-center">
                                    <a href="http://www.age-label.com/parents" target="_blank">
                                        <picture :data-iesrc="`${cdnUrl}images/jusprog-age-xml-18.png`">
                                            <source :srcset="`${cdnUrl}images/jusprog-age-xml-18.webp`" type="image/webp">
                                            <source :srcset="`${cdnUrl}images/jusprog-age-xml-18.png`" type="image/png">
                                            <img alt="" class="mt-2" width="156" height="31"/>
                                        </picture>
                                    </a>
                                    <a href="https://twitter.com/Erobella_de" target="_blank"
                                       class="footer-twitter-image ml-3 mt-0">
                                        <svg width="24" height="24" viewBox="0 0 1200 1227" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="black"/>
                                        </svg>
                                    </a>
                                </div>

                                <picture :data-iesrc="`${cdnUrl}images/footersssl_small_compressed.png`">
                                    <source :srcset="`${cdnUrl}images/footersssl_small_compressed.webp`" type="image/webp">
                                    <source :srcset="`${cdnUrl}images/footersssl_small_compressed.png`" type="image/png">
                                    <img alt="footer-image" width="342" height="91" class="footersssl"/>
                                </picture>
                            </div>

                            <picture :data-iesrc="footerImageUrl('png')">
                                <source
                                    :srcset="footerImageUrl('webp')"
                                    type="image/webp">
                                <source
                                    :srcset="footerImageUrl('png')"
                                    type="image/png">
                                <img alt="footer-image" class="footer-image" width="320" height="130"/>
                            </picture>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>

</template>

<script>

import RegionSelectorComponent from "@/components/partials/RegionSelectorComponent.vue";
import RebrandRegionSelectorComponent from "@/components/global/RebrandRegionSelectorComponent.vue";
import {isUnitedKingdomRegion} from "@/core/utils/helpers/regions/regionUrlHelper";

function defaultAccordionsOpen() {
    if (typeof window === 'undefined') {
        return true;
    }

    return utils.isDesktop();
}

const data = () => {
    return {
        lodash: _,
        cdnUrl: process.env.MIX_CDN2_URL,
        accordionsOpenByDefault: defaultAccordionsOpen(),
    }
};

function termsUrl() {
    switch (process.env.MIX_REGION_PATH) {
        case 'au' :
            return "/au/erobella-agb/"
        case 'uk' :
            return "/uk/terms/"
        default:
            return "/erobella-agb/"
    }
}

function privacyPolicyUrl() {
    switch (process.env.MIX_REGION_PATH) {
        case 'uk' :
            return "/uk/data-protection/"
        default:
            return "/datenschutzerklarung/"
    }
}

function cookiePolicyUrl() {
    switch (process.env.MIX_REGION_PATH) {
        case 'uk' :
            return "/uk/cookie-policy/"
        default:
            return "/cookie-richtlinie/"
    }
}

function imprintUrl() {
    switch (process.env.MIX_REGION_PATH) {
        case 'uk' :
            return "/uk/legal/"
        default:
            return "/impressum/"
    }
}

function isUkRegion() {
    return isUnitedKingdomRegion();
}

function isProfileView() {
    return this.seoView === 'profile';
}

function footerImageUrl(extension) {
    let region = 'DE';

    if (this.isUkRegion) {
        region = 'UK';
    }

    return `${this.cdnUrl}images/footer_16Jul_2026/footerImage_${region}_v2.${extension}`;
}

export default {
    data,
    computed: {
        ...mapState(['currentUser', 'translate', 'locale', 'regionData', 'seoView']),
        hideFooter() {
            return _.get(this, '$route.meta.hideBannersAndFooterOnMobile', false) && !utils.isDesktop();
        },
        ourMissionUrl() {
            if (typeof window === "undefined" || !this.locale) {
                return '/unsere-mission/';
            }

            switch (this.locale) {
                case 'en' :
                    if (isUnitedKingdomRegion()) {
                        return "/uk/our-mission/"
                    }

                    return "/mission-statement/"
                case 'ro' :
                    return "/declaratie-de-misiune/"
                default:
                    return "/unsere-mission/"
            }
        },
        termsUrl,
        privacyPolicyUrl,
        cookiePolicyUrl,
        imprintUrl,
        isUkRegion,
        isProfileView,
        isFostaSestaActive() {
            return !_.has(this.regionData, 'sectionsToHide.fostaSesta');
        },
    },
    methods: {
        footerImageUrl,
    },
    components: {
        RebrandRegionSelectorComponent,
        RegionSelectorComponent,
    },
};
</script>
